module.exports = __webpack_public_path__ + "static/media/main-large-section-3.6ce8203e.png";